<svelte:options accessors/>
<script lang="ts">
    import NauiExplorer from "../../naui/pages/NauiExplorer.svelte";
    import PaymentBar from "./PaymentBar.svelte";
    import type {IMobileFieldSchema, ITableField} from "../../interfaces";
    import Dialog, {Title, Content, Actions} from '@smui/dialog';
    import PagosResumen from "./PagosResumen.svelte";
    import {httpRequest, debounce} from "../../utils";
    import {onMount} from "svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";

    export let url_pagos;
    export let data = [];
    export let columns: Array<ITableField> = [];
    export let mobileSchema: IMobileFieldSchema;
    export let hideSearch = false;
    export let filters;

    let openSummary = false;
    let filtered = [];
    let selected = [];
    let link = ''
    let disableSearch = false;
    let currentSearch: string = '';
    let searchResult = [];
    let explorer: any;

    let open = false;
    let dialogMessage = '';
    let paymentBarCmpt;

    $: total = selected.reduce((prev, current) => prev + current.valor, 0);

    export let resumen;
    export let detalles = false;

    onMount(() => {
        filtered = data;
        const col = columns.find(c => c.slug === 'fecha-vencimiento');
        if (col) {
            col.customClass = (slug: any) => {
                const item = data.find(d => d.slug === slug)
                if (+item['estado-pago'].code === 3) {
                    return 'fecha-vence';
                }
                return '';
            };
        }
    });


    function checked(event) {
        selected = event.detail;
        validateCheck();
        dbPayment();
    }

    function syncChecks() {
        const slugs: any = {};
        for (const item of selected) {
            slugs[item.slug] = true;
        }
        explorer.updateChecked(slugs);
    }

    function removePayment(event) {
        selected = selected.filter(s => s.slug !== event.detail);
        validateCheck();
        dbPayment();
    }

    function getPaymentLink() {
        link = '';
        if (selected.length < 1) {
            return;
        }
        httpRequest({
            method: 'post',
            data: {referencias: selected.map(d => d.ReferenciaDePago)},
            url: url_pagos
        })
            .then(res => res.json())
            .then(data => {
                link = data.url;
            });
    }

    let dbPayment = debounce(getPaymentLink, 400);
    let dbFilter = debounce(filterData, 400);

    async function filterData(e) {
        if (disableSearch) {
            return;
        }
        disableSearch = true;
        if (e.detail.term && e.detail.term.length > 2) {
            if (e.detail.term !== currentSearch) {
                currentSearch = e.detail.term;
                const searchResponse = await httpRequest({
                    method: 'get',
                    data: {term: e.detail.term},
                    url: ''
                }).then(res => res.json());
                searchResult = searchResponse.data;
            }
            filtered = searchResult;
        } else {
            filtered = data;
        }
        const filters = e.detail.filters;
        if (filters.estadoPago) {
            filtered = filtered.filter(d => {
                return d['estado-pago'].code === +filters.estadoPago;
            });
        }
        if (filters.descripcion) {
            filtered = filtered.filter(d => d.descripcion === filters.descripcion);
        }
        if (filters.fechaVencimiento) {
            const dts = filters.fechaVencimiento.split(' - ');
            const min = new Date(dts[0]).getTime();
            const max = new Date(dts[1]).getTime();

            filtered = filtered.filter(d => {
                const splitDate = d['fecha-vencimiento'].split('/');
                const ven = new Date(`${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`).getTime();
                return ven >= min && ven <= max;
            });
        }

        disableSearch = false;
    }

    function validateCheck() {
        const toRemove = [];
        const toAdd = [];
        let currentTotal = selected.reduce((t, item) => t + item.valor, 0)
        const error = {
            order: false
        };


        for (const [index, item] of selected.entries()) {
            let policyItems = [...data];
            if (!detalles) {
                policyItems = data.filter(i => i.numero === item.numero);
                if (policyItems.some(i => +i.endoso < +item.endoso && !i.selected && i.valor > 0)) {
                    toRemove.unshift(index);
                    item.selected = false;
                    // Error en orden
                    error.order = true;
                }

            } else {
                if (policyItems.some(i => +i.numero < +item.numero && !i.selected)) {
                    toRemove.unshift(index);
                    item.selected = false;
                    // Error en orden
                    error.order = true;
                }
            }
            if (item.valor < 0 && item.TipoDeSaldo.toUpperCase() === "SCM") {
                const total_seleccionado = policyItems
                    .filter(s => s.selected && s.valor > 0)
                    .reduce((t, i) => t + i.valor, 0);
                if (total_seleccionado + item.valor < 0) {
                    toRemove.unshift(index);
                    item.selected = false;
                }
            }
            const negativeItems = policyItems.filter(i => i.valor < 0);
            for (const item of negativeItems) {
                if (currentTotal + item.valor > 0) {
                    item.selected = true;
                    currentTotal += item.valor;
                }
            }
        }
        for (const index of toRemove) {
            selected.splice(index, 1);
        }
        for (const item of toAdd) {
            selected.push(item);
        }
        selected = selected;
        syncChecks();
        if (paymentBarCmpt) {
            const items = [];
            if (error.order) {
                items.push('Seleccione los saldos a pagar en orden de vencimiento del más antiguo hacia adelante');
            }
            paymentBarCmpt.alertMessages = items;
        }
    }

    function showAlert(message: string) {
        open = true;
        dialogMessage = message;
    }
</script>
<div>
    <div>
        <NauiExplorer {hideSearch}
                      {mobileSchema}
                      {columns}
                      {filters}
                      data={filtered}
                      searchLabel="Buscar por No. Póliza o No. Placa"
                      hideCount="{true}" on:filter={dbFilter} {disableSearch}
                      bind:this={explorer}
                      on:checked={checked}/>
    </div>
    <PaymentBar bind:this={paymentBarCmpt} {total} {link} on:details={()=>openSummary=true}/>
    <PagosResumen {total} {link} {resumen} bind:open={openSummary} bind:data="{selected}" on:remove={removePayment}/>

    <Dialog bind:open>
        <Content>{ dialogMessage }</Content>
        <Actions>
            <NauiButton caption="Aceptar" color="accent" mode="solid" on:click={() => {open = false;}}/>
        </Actions>
    </Dialog>
</div>